import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import { ChipGridInput, ChipGridOutput } from '@trackback/widgets';
import { BaseWidgetComponent } from '../base-widget.component';
import { NgClass } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { MatIconModule } from '@angular/material/icon';

@Register('ChipGrid')
@Component({
  selector: 'tb-chip-grid',
  templateUrl: './chip-grid.component.html',
  styleUrls: ['./chip-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatChipsModule, DynamicWidgetDirective, NgClass, MatIconModule],
})
export class ChipGridComponent
  extends BaseWidgetComponent<ChipGridInput, ChipGridOutput>
  implements OnInit, OnDestroy {}
